import type {
  ButtonDTO,
  ProductButtonVariant,
  SanityButton,
  SanityProductVariantButton,
} from '../product-variant.types';
import { mapLink } from './map-link';

/**
 * Normalizes button style by converting to uppercase
 */
export const normalizeButtonStyle = (style: string | undefined): ProductButtonVariant => {
  if (!style) return 'PRIMARY';
  return style.toUpperCase() as ProductButtonVariant;
};

/**
 * Maps a Sanity button to ButtonDTO
 */
export const mapButton = (b: SanityButton | undefined | null): ButtonDTO | undefined => {
  if (!b) return undefined;

  // Handle button structure from productVariantSection (has label and link)
  if (b._type === 'button' && b.link) {
    const link = mapLink(b.link);
    if (!b.label || !link) return undefined;

    return {
      label: b.label,
      style: normalizeButtonStyle(b.style),
      link,
    };
  }

  return undefined;
};

/**
 * Maps buttons from product variant items (different structure)
 */
export const mapVariantButton = (b: SanityProductVariantButton | undefined | null): ButtonDTO | undefined => {
  if (!b) return undefined;

  // Handle button structure from productVariant.buttons
  if ((b.type === 'button' || b.type === 'hyperlink') && b.url) {
    const link = mapLink({
      _type: 'linkOptional',
      url: b.url,
      isOpenInNewTab: b.openInNewTab,
      type: 'internal',
    });
    if (!b.text || !link) return undefined;

    // Map button style from new structure
    let style: ProductButtonVariant = 'PRIMARY';
    if (b.buttonStyle === 'secondary') style = 'SECONDARY';
    else if (b.buttonStyle === 'outline') style = 'GHOST';

    return { label: b.text, style, link };
  }

  return undefined;
};
